import React, {useEffect, useState} from 'react';
import MicroreelsLibraryUI from '../view/MicroreelsLibraryUI';
import {inject, observer} from 'mobx-react';
import MicroreelsLibraryStore from '../store/MicroreelsLibraryStore';
import {useParams} from 'react-router-dom';
import {Microlesson} from '../../../data/models/Microlessons/Microlesson';

interface Props {
  microreelsLibraryStore?: MicroreelsLibraryStore;
}

export const ITEMS_PER_PAGE = 9;

const MicroreelsLibraryContainer = inject('microreelsLibraryStore')(
  observer(({microreelsLibraryStore}: Props) => {
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [reels, setReels] = useState<Microlesson[]>([]);
    const [pagesCount, setPagesCount] = useState(0);

    const {organizationId, courseId, folderId} = useParams();

    useEffect(() => {
      setSearch('');
      setCurrentPage(1);
      if (organizationId && microreelsLibraryStore!.showLibrary) {
        microreelsLibraryStore!
          .getMicroreelsLibrary(organizationId, 0, ITEMS_PER_PAGE, '')
          .then(res => {
            setReels(res.data);
            setPagesCount(res.pagesCount);
          });
      }
    }, [microreelsLibraryStore!.showLibrary]);

    useEffect(() => {
      fetchReels();
    }, [currentPage]);

    useEffect(() => {
      setCurrentPage(1);
      fetchReels();
    }, [search]);

    const fetchReels = () => {
      if (organizationId) {
        microreelsLibraryStore!
          .getMicroreelsLibrary(
            organizationId,
            currentPage - 1,
            ITEMS_PER_PAGE,
            search,
          )
          .then(res => {
            setReels(res.data);
            setPagesCount(res.pagesCount);
          });
      }
    };

    const onCancel = () => {
      microreelsLibraryStore!.closeLibrary();
    };

    const onCopyReels = (microreelIds: string[]) => {
      if (courseId && organizationId && folderId) {
        microreelsLibraryStore!.copyMicroreelsToCourse(
          organizationId,
          courseId,
          folderId,
          microreelIds,
        );
      }
    };

    return microreelsLibraryStore?.showLibrary ? (
      <MicroreelsLibraryUI
        search={search}
        setSearch={setSearch}
        onCancel={onCancel}
        reels={reels}
        currentPage={currentPage}
        pages={pagesCount}
        onPageChange={setCurrentPage}
        onCopyReels={onCopyReels}
        isLoading={microreelsLibraryStore!.isLoading}
      />
    ) : null;
  }),
);

export default MicroreelsLibraryContainer;
